import "./buzonAnonimo.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import BuzonAnonimoAdmin from "../../components/buzonAnonimo/BuzonAnonimoAdmin"
import { useSidebarState } from "../../components/sidebar/SidebarStateContext";

/**
 * Componente de la página del buzón anónimo para administradores.
 *
 * @returns {JSX.Element} Elemento JSX que representa la página del buzón anónimo.
 */
const BuzonAnonimo = () => {
  const { collapsed } = useSidebarState();
  // Agregar una clase basada en el estado de colapso
  const containerClass = collapsed ? "buzonContainer collapsed" : "buzonContainer";

  return (
    <div data-testid="sidebar-buzon" className="buzon">
      <Sidebar />
      <div data-testid="navbar-buzon" className={containerClass}>
        <Navbar />
        <BuzonAnonimoAdmin />
      </div>
    </div>
  )
}

export default BuzonAnonimo